import { InputHTMLAttributes, forwardRef } from "react";

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  iconColor?: string;
  onClear?: () => void;
  showClear?: boolean;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ containerClassName = "", className = "", iconColor = "#8F9098", onClear, showClear, value, ...rest }, ref) => {
    const clearable = typeof showClear === "boolean" ? showClear : typeof value === "string" && value.length > 0;

    return (
      <label className={`h-11 bg-[#FAFAFA] border border-[#E8E9F1] rounded-[6px] flex items-center gap-2 px-3 cursor-text ${containerClassName}`}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="shrink-0">
          <circle cx="11" cy="11" r="7" stroke={iconColor} strokeWidth="2" />
          <path d="M20 20l-3.5-3.5" stroke={iconColor} strokeWidth="2" strokeLinecap="round" />
        </svg>
        <input
          ref={ref}
          value={value}
          className={`flex-1 min-w-0 bg-transparent outline-none border-0 font-opensans text-[14px] text-[#0E0809] placeholder:text-[#8F9098] ${className}`}
          {...rest}
        />
        {clearable && onClear && (
          <button type="button" aria-label="Clear search" onClick={onClear} className="shrink-0 w-6 h-6 flex items-center justify-center bg-transparent border-0 p-0">
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
              <path d="M1 1l12 12M13 1L1 13" stroke="#8F9098" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
          </button>
        )}
      </label>
    );
  }
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
